import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];

  connect() {
    if (this.containerTarget.classList.contains("hidden")) {
      this.disableFields();
    }
  }

  toggle(event) {
    const showContainer = event.target.value === "No";

    if (showContainer) {
      this.containerTarget.classList.remove("hidden");
      this.enableFields();
    } else {
      this.containerTarget.classList.add("hidden");
      this.disableFields();
    }
  }

  disableFields() {
    const inputs = this.containerTarget.querySelectorAll("input[required], select[required]");
    inputs.forEach((input) => {
      input.dataset.wasRequired = "true";
      input.removeAttribute("required");
    });
  }

  enableFields() {
    const inputs = this.containerTarget.querySelectorAll("input, select");
    inputs.forEach((input) => {
      if (input.dataset.wasRequired === "true") {
        input.setAttribute("required", "required");
        delete input.dataset.wasRequired;
      }
    });
  }
}
